// Dependencies
import styled from 'styled-components';

export const AvatarContainer = styled.div`
  background-color: ${({ theme }) => theme.colors.garnet};
  width: 4.5rem;
  height: 4.5rem;
  border-radius: ${({ theme }) => theme.borderRadius.full};
  color: ${({ theme }) => theme.colors.white};
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  padding: 0;
  border: none;
  min-width: 2.4rem;
  max-width: 5rem;
`;
